import { pathToUrl } from '@domain/routes/urls';
import { ICoordinates } from '@app-types/geo';

interface RawBoundary {
  id: number;
  area: string;
  name: string;
  rank: number;
  prohibited: number;
  prohibited_message: string;
  locales: string;
  is_top_level: number;
  freshwater: number;
  saltwater: number;
  regulation_notes: string;
}

export interface Boundary {
  id: number;
  name: string;
  rank: number;
  prohibited: boolean;
  prohibitedMessage: string;
  regulationNotes: string;
}

interface ApiResult {
  success: boolean;
  results: {
    rawBoundaries: RawBoundary[];
    transformedBoundaries: RawBoundary[];
  };
}

function transformBoundary(b: RawBoundary): Boundary {
  return {
    name: b.name,
    id: b.id,
    regulationNotes: b.regulation_notes,
    prohibited: b.prohibited === 1,
    prohibitedMessage: b.prohibited_message,
    rank: b.rank,
  };
}

export async function getBoundariesAtLocation(
  { latitude, longitude }: ICoordinates,
  signal: AbortSignal = new AbortController().signal,
): Promise<Boundary[]> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-boundaries-at-location'), {
    body: JSON.stringify({ latitude, longitude }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: ApiResult = await response.json();
  if (!json.success) {
    return [];
  }
  return json.results.transformedBoundaries.map(transformBoundary);
}
